import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DeviceTypeService } from '../../../core/services/device-type.service';

@Component({
  selector: 'app-support-button',
  imports: [CommonModule],
  templateUrl: './support-button.component.html',
  styleUrl: './support-button.component.scss'
})
export class SupportButtonComponent {
  @Input() phone: string = '';

  showPopup = false;

  constructor(
    private deviceTypeService: DeviceTypeService
  ) { }

  onSupportClick() {
    const source = this.deviceTypeService.getUserSource();

    switch (source) {
      case 'ios_web':
      case 'android_web':
      case 'mobile_web':
        // Mobile devices → open dialer
        window.location.href = `tel:${this.phone}`;
        break;

      case 'web':
      default:
        // Desktop → toggle popup
        this.showPopup = !this.showPopup;
        break;
    }
  }

  closeSupportPopup() {
    this.showPopup = false;
  }
}
